// Google Analytics 4 (GA4) helper.
// Loads gtag from public/index.html. This module wraps calls safely so the app
// never breaks if the GA script is blocked or not yet loaded, and ensures no
// personally identifiable information (PII) is ever sent to Google Analytics.

const GA_ID = "G-XW36W0ZRZM";

const gtagReady = () => typeof window !== "undefined" && typeof window.gtag === "function";

/**
 * Send a manual page_view. Called on every route change so navigation between
 * client-side routes is tracked without duplicating the initial load event
 * (automatic page_view is disabled via send_page_view: false).
 */
export const trackPageView = (path) => {
  if (!gtagReady()) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_ID,
  });
};

/**
 * Send a custom GA4 event. Only pass non-PII parameters (never name/email/phone).
 */
export const trackEvent = (name, params = {}) => {
  if (!gtagReady() || !name) return;
  window.gtag("event", name, params);
};
